import { ReactNode } from 'react'
import { Flex } from 'antd'
import cn from 'classnames'
import s from './s.module.css'
import CheckIcon from './checkIcon.svg?react'
import Icon from '@/shared/components/Icon'

export type Props = {
  code: string
  icon?: string
  onClick?: () => void
  isSelected?: boolean
  children: ReactNode
}

export default function Option({ isSelected, icon, code, onClick, children }: Props) {
  return (
    <Flex gap={8} align="center" className={cn(s.wrap, { [s.selected]: isSelected })} onClick={onClick}>
      {icon && <Icon iconSrc={icon} iconSize={16} code={code} />}
      {children}
      {isSelected && (
        <div className={s.iconCheck}>
          <CheckIcon />
        </div>
      )}
    </Flex>
  )
}
